module.exports = __webpack_public_path__ + "img/circular-car-loan.05520023.png";